import React, { CSSProperties } from "react";
import cn from "classnames";
import styles from "./style.module.scss";

interface ButtonProps {
  text: string;
  icon?: string;
  onClick?: (e) => void;
  classnames?: string | string[];
  iconStyles?: CSSProperties;
}

const Button = ({
  text,
  icon,
  onClick = () => {},
  classnames,
  iconStyles,
}: ButtonProps) => {
  return (
    <div onClick={onClick} role="button" className={cn(classnames, styles.button)}>
      {icon && (
        <img src={icon} alt="icon" className={styles.icon} style={iconStyles} />
      )}
      {text}
    </div>
  );
};

export default Button;
